<div
  class="mb-0"
  [ngClass]="{
    'alert alert-warning': hasNewUnhandledCases() && !error() && !isLoading() && hasScreeningParams(),
    'alert alert-success': !hasNewUnhandledCases() && !error() && !isLoading() && hasScreeningParams(),
  }">
  @if (!isLoading() && hasScreeningParams()) {
    @if (hasNewUnhandledCases()) {
      <h5>
        <i class="fa fa-exclamation-triangle me-2"></i
        >{{ 'screening.screening_overrides.screening_case_table.title' | translate }}
      </h5>
    } @else {
      <h5 class="mb-0">
        <i class="fa fa-check me-2"></i
        >{{ 'screening.screening_overrides.screening_case_table.nothing_to_review' | translate }}
      </h5>
    }
  }

  @if (error() && !isLoading()) {
    <nk-error-alert [error]="error()!"></nk-error-alert>
  }

  @if (isLoading()) {
    <nk-progress [isLoading]="true"></nk-progress>
  }

  <div class="text-black">
    @if (data$ | async; as data) {
      @if (data.pagination.totalCount) {
        <nk-card-list
          [cardListConfig]="cardListConfig"
          [data]="data"
          [isLoading]="isLoading()"
          [collapsibleDetails]="collapsibleDetails()"
          (changePage)="onChangePage($event)"></nk-card-list>
      }
    }
  </div>
</div>
